import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-ia-activity-description',
  templateUrl: './modal-ia-activity-description.page.html',
  styleUrls: ['./modal-ia-activity-description.page.scss'],
})
export class ModalIaActivityDescriptionPage implements OnInit {

  @Input() iaActivity: any;

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
